<template>
  <div>
    <b-table small ref="table" :busy="isBusy" striped hover responsive="true"
      :items="users"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      selectable
      @row-selected="onRowSelected"
      select-mode="single"
      caption-top>
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t('Loading...') }}</strong>
      </div>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="ClickOnPromisedPaymentButton(row)" variant="outline-primary">
          {{ $t('Promised payment') }}
        </b-button>
        <b-button size="sm" @click.stop="ClickOnPaymentButton(row)" variant="info">
          {{ $t('Payment') }}
        </b-button>
        <b-button size="sm" @click.stop="ClickOnDocumentButton(row)" id="transparent">
          <b-img :src='downloagDocumentImage' />
        </b-button>
        <b-button size="sm" @click.stop="ClickOnDeleteUserButton(row)" id="transparent">
          <b-img :src='deleteDocumentImage' />
        </b-button>
      </template>
      <template slot="row-details" slot-scope="row">
        <div style="margin:1px">
          <Detail ref="Detail" :currentRow="row.item" @makeToasts="makeToasts" @refreshTable="refreshTable" @refreshRow="refreshRow"/>
        </div>
      </template>
    </b-table>

    <b-modal ref="modalPromisedPaymentValue" hide-footer :title="$t('Promised payment')" v-if="currentRow">
        <b-form-group :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="promisedPaymentValue" id="popover"/>
        </b-form-group>
        <b-popover target="popover" triggers="hover" placement="top">
          <template v-slot:title/>
          {{ $t('Possible value from 0 to') }} {{ this.maxValue }}
        </b-popover>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-payment-settings variant="outline-sucess">{{ $t('OtherSettings') }}</b-button>
        </b-card-header>
        <b-collapse id="accordion-payment-settings" accordion="accordion-payment-settings" role="tabpanel">
          <b-card-body>
            <b-form-group :label="$t('Max payment')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled >
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.max_value"/>
            </b-form-group>
            <b-form-group :label="$t('Expires in (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.max_duration"/>
            </b-form-group>
            <b-form-group :label="$t('Interval between uses (days)')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.interval_duration"/>
            </b-form-group>
            <b-form-group :label="$t('Min balance')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.min_balance"/>
            </b-form-group>
            <b-form-group :label="$t('Free if balance over')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
              <b-form-input type="text" v-model="promisedPaymentOtherSettings.once_service_cost"/>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-row style="padding:10px">
        <b-col>
          <b-button variant="success" style="float: right; width: 100px" @click="makePromisedPayment()">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button variant="secondary" style="float: right; width: 100px" @click="hideModal()">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="fileTypeChoice" hide-footer :title="$t('Choose filename')">
      <b-row>
        <b-col>
          <b-form-input v-model="fileName" :placeholder="$t('Enter filename')"></b-form-input>
        </b-col>
        <b-col>
          <b-form-select v-model="selectedFileType" :options="options" class="mb-3"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn variant="success" block @click="downloadDocument(currentRow)">{{ $t('Download') }}</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideModal()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteUser">
      <h5>{{ $t('Are you sure you want to delete one of "User"?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteUser()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideModal()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'
import download from 'downloadjs'
import Detail from '@/pages/users/usersAndGroups/detail/main'

export default {
  props: {
    filter: {
      type: String
    },
    perPage: {
      type: Number
    },
    currentPage: {
      type: Number
    },
    curCustomers: 0
  },
  components: {
    Detail
  },
  data () {
    return {
      maxValue: 0,
      users: [],
      fields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'basic_account', label: this.$i18n.t('Basic account'), sortable: true },
        { key: 'full_name', label: this.$i18n.t('FullName'), sortable: true },
        { key: 'email', label: this.$i18n.t('Email') },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      options: [
        { value: 0, text: 'odt' },
        { value: 1, text: 'pdf' }
      ],
      currentRow: null,
      selectedFileType: 1,
      fileName: '',
      promisedPaymentOtherSettings: {
        'interval_duration': 0,
        'max_duration': 0,
        'max_value': 0,
        'once_service_cost': 0,
        'min_balance': 0
      },
      promisedPaymentText: '',
      promisedPaymentValue: 0,
      downloagDocumentImage: require('@/assets/img/download.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      isBusy: true,
      selected: []
    }
  },
  methods: {
    onRowSelected (items) {
      for (let i in this.selected) {
        for (let j in items) {
          if (this.selected[i] === items[j]) {
            break
          }
        }
        this.selected[i]._showDetails = false
      }
      this.selected = items
      for (let i in this.selected) {
        this.selected[i]._showDetails = true
      }
    },
    makePromisedPayment () {
      let promisedPayment = {
        account_id: this.currentRow.item.basic_account,
        user_id: this.currentRow.item.user_id,
        value: parseFloat(this.promisedPaymentValue)
      }
      axiosInstance.post(this.$store.getters.API_TARIFFING_PROMISED_PAYMENTS, promisedPayment).then(response => {
        if (response.data.error) {
          this.promisedPaymentText = response.data.error
          this.$root.$emit('makeToasts', 'danger', this.promisedPaymentText, 'Error')
        } else {
          this.hideModal()
          this.load()
        }
      })
    },
    async ClickOnPromisedPaymentButton (row) {
      this.currentRow = row
      axiosInstance.get(this.$store.getters.API_TARIFFING_PROMISED_PAYMENTS + '?user_id=' + row.item.user_id + '&account_id=' + row.item.basic_account).then((response, err) => {
        let promisedPaymentSettings = response.data
        if (promisedPaymentSettings.error) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Promised payment settings not found for this user'), 'Error')
          this.hideModal()
        } else {
          if (Number(promisedPaymentSettings.is_possible) === 1) {
            this.promisedPaymentOtherSettings = promisedPaymentSettings
            this.maxValue = this.promisedPaymentOtherSettings.max_value
            this.promisedPaymentOtherSettings.max_duration = this.promisedPaymentOtherSettings.max_duration / 86400
            if (this.promisedPaymentOtherSettings.interval_duration > 0) {
              this.promisedPaymentOtherSettings.interval_duration = this.promisedPaymentOtherSettings.interval_duration / 86400
            }
            this.promisedPaymentValue = promisedPaymentSettings.max_value
            this.$refs.modalPromisedPaymentValue.show()
          } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Promised payment not avaible for this user'), 'Error')
            this.hideModal()
          }
        }
      })
    },
    ClickOnDeleteUserButton (row) {
      this.currentRow = row
      this.$refs.modalDeleteUser.show()
    },
    async deleteUser () {
      for (let el of this.currentRow.item.accounts) {
        let seviceLinks = await axiosInstance.get(this.$store.getters.API_USERS_SERVICE_LINKS + '?account_id=' + el).then(response => { return response.data })
        if (seviceLinks.length > 0) {
          for (let elServices of seviceLinks) {
            if (elServices.service_type === 3) {
              let response = await this.$store.dispatch('Tariffing/DELETE_RADIUS_SESSION', elServices.service_link_id).then(response => { return response.data })
              if (response.error) {
                this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
              }
            }
            axiosInstance.delete(this.$store.getters.API_USERS_SERVICE_LINKS, {data: { 'slink_id': elServices.service_link_id }}).then(response => {
              if (response.data.error) {
                this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
              }
            })
          }
        }
        let tariffLinks = await axiosInstance.get(this.$store.getters.API_USERS_TARIFFLINKS + '?user_id=' + this.currentRow.item.user_id + '&account_id=' + el).then(response => { return response.data })
        if (tariffLinks.length > 0) {
          for (let elTariffs of tariffLinks) {
            axiosInstance.delete(this.$store.getters.API_USERS_TARIFFLINKS + '?user_id=' + this.currentRow.item.user_id + '&account_id=' + el + '&tplink_id=' + elTariffs.id).then(response => {
              if (response.data.error) {
                this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
              }
            })
          }
        }
      }
      let response = this.$store.dispatch('Users/DELETE_USERS', this.currentRow.item.user_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.load()
          this.$root.$emit('makeToasts')
          this.$refs.modalDeleteUser.hide()
        }
      })
    },
    ClickOnPaymentButton (row) {
      this.$emit('ClickOnPaymentButton', row.item)
    },
    ClickOnDocumentButton (row) {
      this.currentRow = row
      this.fileName = row.item.login + '_doc'
      this.$refs.fileTypeChoice.show()
    },
    hideModal () {
      this.$refs.fileTypeChoice.hide()
      this.$refs.modalPromisedPaymentValue.hide()
      this.$refs.modalDeleteUser.hide()
    },
    downloadDocument (row) {
      this.hideModal()
      if (this.selectedFileType === 0) {
        this.fileName += '.odt'
      } else {
        this.fileName += '.pdf'
      }
      let userId = row.item.user_id
      let docType = 3
      let baseId = row.item.user_id
      axiosInstance.get(this.$store.getters.API_USERS_DOCUMENTS + '?user_id=' + userId + '&doc_type=' + docType + '&base_id=' + baseId + '&file_type=' + this.selectedFileType, {
        responseType: 'blob'}).then(response => {
        download(response.data, this.fileName, 'application/pdf')
      })
    },
    load (newFilter) {
      for (let i in this.selected) {
        this.selected[i]._showDetails = false
      }
      this.selected = []
      let curFilter = newFilter || this.filter
      this.isBusy = true
      axiosInstance.post(this.$store.getters.API_USERS_SEARCH, { 'value': curFilter }).then(response => {
        var users = response.data
        users = users.filter((value) => {
          return value.card_user === this.curCustomers
        })
        for (var i in users) {
          this.prepareUser(users[i])
        }

        this.users = users
        this.$emit('input', this.users.length)
        this.isBusy = false
      })
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    showModalDelete () {
      this.$emit('showModalDelete')
    },
    refreshTable (filter = '') {
      this.filter = filter
      this.load(filter)
    },
    prepareUser (user) {
      if (user.is_active_block) {
        user._cellVariants = {user_id: 'danger'}
      } else {
        user._cellVariants = {user_id: 'success'}
      }
      user.balance = Number.parseFloat(user.balance).toFixed(3)
      user._showDetails = false
    },
    async refreshRow (id, showDetails) {
      let user = await axiosInstance.get(this.$store.getters.API_USERS + '?user_id=' + id).then(response => { return response.data })
      this.prepareUser(user)
      for (let i in this.users) {
        if (this.users[i].user_id === user.user_id) {
          this.users[i] = user
          break
        }
      }
      this.$refs.table.refresh()
      user._showDetails = showDetails
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    curCustomers () {
      this.load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/users/Users.vue